import React from 'react';
import { Box, Typography, Avatar, List, ListItemButton, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import SimCardIcon from '@mui/icons-material/SimCard';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import EventNoteIcon from '@mui/icons-material/EventNote';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getCookie, removeCookie } from '../../../utils/helper';
import { ButtonUI } from '../../../component/CustomerMUI';

const Sidebar = ({ authDomain, hostname }) => {
  const location = useLocation();

  const menuConfig = [
    { title: 'Tổng Quan', icon: <DashboardIcon />, path: '/dashboard', show: true },
    {
      title: 'Quản Lý Admin',
      icon: <PermContactCalendarIcon />,
      path: '/dashboard/admin',
      show: ['1', '2', '3', '6', '7', '4'].includes(authDomain?.permission),
    },
    {
      title: 'Excel Sim',
      icon: <EventNoteIcon />,
      path: '/dashboard/excel',
      show: authDomain?.permission === '3' && hostname === 'khoso.com.vn',
    },
    {
      title: 'Lọc Excel',
      icon: <EventNoteIcon />,
      path: '/dashboard/loc',
      show: authDomain?.permission === '3' && hostname === 'sale.khoso.com.vn',
    },
    {
      title: 'Quản Lý Giao Diện',
      icon: <ViewQuiltIcon />,
      path: '/dashboard/giaodien',
      show: ['1', '2', '3', '6', '7', '4'].includes(authDomain?.permission),
    },
    { title: 'Bảng Sim Cá Nhân', icon: <SimCardIcon />, path: '/ctv', show: true },
    {
      title: 'Công Tác Viên',
      icon: <PeopleAltIcon />,
      path: '/dashboard/dsctv',
      show: ['3', '7'].includes(authDomain?.permission),
    },
    {
      title: 'SIM Đang Load',
      icon: <PublishedWithChangesIcon />,
      path: '/dashboard/dsloadsim',
      show: ['3', '7', '5'].includes(authDomain?.permission),
    },
    {
      title: 'Quản Lý Sản Phẩm',
      icon: <ShoppingBagIcon />,
      path: '/dashboard/shops',
      show: ['3', '6'].includes(authDomain?.permission),
    },
    {
      title: 'Làm Nhiều Ảnh',
      icon: <AddPhotoAlternateIcon />,
      path: '/photo',
      show: ['1', '2', '3', '6', '7', '4'].includes(authDomain?.permission),
    },
    { title: 'Công Nợ (Thu-Chi)', icon: <EventNoteIcon />, path: '/congno', show: authDomain?.permission !== '5' },
    {
      title: 'Thông Báo Sim',
      icon: <NotificationsActiveIcon />,
      path: '/dashboard/notifisim',
      show: ['1', '2', '3', '6', '7', '4'].includes(authDomain?.permission),
    },
    {
      title: 'Flash Sale',
      icon: <OfflineBoltIcon />,
      path: '/dashboard/flashsale',
      show: ['3', '6', '7', '4'].includes(authDomain?.permission),
    },
    {
      title: 'Bài Viết News',
      icon: <ArticleRoundedIcon />,
      path: '/dashboard/news',
      show: ['1', '2', '3', '6', '7', '4'].includes(authDomain?.permission),
    },
    {
      title: 'Sim DiGiShop',
      icon: <CardGiftcardIcon />,
      path: '/dashboard/digishop',
      show: authDomain?.permission === '3',
    },
  ];
  const navigate = useNavigate();
  const handleNav = () => {
    navigate('/dashboard', { replace: true });
    window.location.reload();
  };

  return (
    <Box sx={{ height: '100%', bgcolor: '#FFF', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 1.5 }} onClick={() => handleNav()}>
        <Box
          sx={{
            width: 40,
            height: 40,
            bgcolor: '#3B82F6',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFF',
            fontSize: '1.2rem',
            fontWeight: 800,
            fontFamily: 'FS',
          }}
        >
          SỐ
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 800, color: '#1E293B', letterSpacing: '-0.5px', fontFamily: 'FS' }}>
          SIM PANEL
        </Typography>
      </Box>

      <List sx={{ px: 2, flexGrow: 1, overflowY: 'auto' }}>
        <Typography
          variant="caption"
          sx={{ px: 2, color: '#94A3B8', fontWeight: 700, textTransform: 'uppercase', mb: 1, display: 'block' }}
        >
          Hệ Thống
        </Typography>
        {menuConfig.map(
          (item, idx) =>
            item.show && (
              <ListItemButton
                key={idx}
                component={Link}
                to={item.path}
                selected={location.pathname === item.path}
                sx={{
                  borderRadius: '12px',
                  mb: 0.5,
                  color: location.pathname === item.path ? '#3B82F6' : '#64748B',
                  bgcolor: location.pathname === item.path ? '#3B82F610' : 'transparent',
                  '&.Mui-selected': { bgcolor: '#3B82F615', '&:hover': { bgcolor: '#3B82F620' } },
                }}
              >
                <ListItemIcon sx={{ minWidth: 38, color: 'inherit' }}>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 900, fontFamily: 'UTM-Avo' }}
                />
                {location.pathname === item.path && <ChevronRightIcon sx={{ fontSize: 16 }} />}
              </ListItemButton>
            ),
        )}
      </List>

      <Box sx={{ p: 2, borderTop: '1px solid #F1F5F9' }}>
        <Stack direction="row" alignItems="center" sx={{ pt: 1.5, pb: 1.5, bgcolor: '#F8FAFC', borderRadius: '12px' }}>
          {getCookie('token') && (
            <ButtonUI
              borderBtn="#d1fae5"
              color="error"
              onClick={() => {
                removeCookie('token');
                removeCookie('token_sv');
                removeCookie('exp_sv');
                navigate('/user/login', { replace: true });
              }}
            >
              Đăng xuất
            </ButtonUI>
          )}
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ p: 1.5, bgcolor: '#F8FAFC', borderRadius: '12px' }}
        >
          <Avatar sx={{ width: 36, height: 36, bgcolor: '#3B82F6', fontSize: '1rem' }}>A</Avatar>
          <Box sx={{ overflow: 'hidden' }}>
            <Typography noWrap sx={{ fontSize: '0.8rem', fontWeight: 700 }}>
              Admin #{authDomain?.permission}
            </Typography>
            <Typography noWrap sx={{ fontSize: '0.7rem', color: '#64748B' }}>
              {hostname}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default Sidebar;
